<template>
  <i18n-t
    :keypath="keypath"
    :plural="count"
    :count="count"
    :tag="tag"
    scope="global"
  >
    <template
      v-for="{ name, camelCaseName } in slotNames"
      v-slot:[camelCaseName]
    >
      <slot :name="name" />
    </template>
  </i18n-t>
</template>

<script setup lang="ts">
import { camelCase } from 'lodash-es'
import { computed, useSlots } from '@/composition/vue/compositionApi'
import type { TranslationKey } from '@/services/types'

defineProps<{
  keypath: TranslationKey | string
  count?: number
  tag?: string
}>()

const slots = useSlots()
const slotNames = computed(() => {
  const names = Object.keys(slots)
  return names.map((name) => ({
    name,
    camelCaseName: camelCase(name),
  }))
})
</script>
